import {$, w} from './constants';

$(document).ready(function () {

    // N e w s  H o m e //
    if ($('#home_latest_news').length) {
        let page_id = $('#page_id').val();
        let category;

        const isMobile = window.matchMedia("(max-width: 950px)").matches;

        if (isMobile) {
            // Mobile: leer del <select>
            category = $('#filter_news_categories_mobile').val();
        } else {
            // Desktop: leer del <li class="active">
            const first_category = $('#filter_news_desktop').find('.filter_home_new.active');
            category = first_category.data('filter');
        }
        loadHomeNews( page_id, category);
    }

    $('.filter_home_new').on('click', function(){
        $('.filter_home_new').removeClass('active');
        $(this).addClass('active');
        let page_id = $('#page_id').val();
        let category = $(this).data('filter');
        $('#filter_news_categories_mobile').val(category); // sincroniza móvil
        loadHomeNews( page_id, category);
    });

    $('#filter_news_categories_mobile').on('change', function () {
        let page_id = $('#page_id').val();
        let category = $(this).val();
        $('.filter_home_new').removeClass('active');
        $('.filter_home_new[data-filter="' + category + '"]').addClass('active'); // sincroniza desktop
        loadHomeNews(page_id, category);
    });

    // END N e w s  H o m e //

    // N e w s  i n  T a x o n o m y //
    if ($('#grid_container_tax').length) {
        const urlCategory = getUrlParameter('categoria');

        const isMobile = window.matchMedia("(max-width: 950px)").matches;
        let category;

        if (urlCategory) {
            category = urlCategory;

            if (isMobile) {
                $('#filter_news_categories_grid_mobile').val(category);
            } else {
                $('.filter_grid_block').removeClass('active');
                $('.filter_grid_block[data-filter="' + category + '"]').addClass('active');
            }

            setTimeout(() => {
                scrollToGridWrapper();
            }, 200);

        } else {
            // sin parámetro, usar el que esté activo por default
            category = isMobile
                ? $('#filter_news_categories_grid_mobile').val()
                : $('#filter_news_categories_grid_desktop .filter_grid_block.active').data('filter');
        }

        loadAllNewsByCategory(category, 1, 8);
    }

    $('.filter_grid_block').on('click', function () {
        $('.filter_grid_block').removeClass('active');
        $(this).addClass('active');

        const category = $(this).data('filter');
        // Sincroniza con select móvil
        $('#filter_news_categories_grid_mobile').val(category);

        loadAllNewsByCategory(category, 1, 8);
        
    });

    $('#filter_news_categories_grid_mobile').on('change', function () {
        const category = $(this).val();
        // Sincroniza con desktop
        $('.filter_grid_block').removeClass('active');
        $('.filter_grid_block[data-filter="' + category + '"]').addClass('active');

        loadAllNewsByCategory(category, 1, 8);
    });

    $('#filter_news_tab_market').on('click', function(){
        $(this).addClass('active');
        $('#filter_news_tab_new').removeClass('active');
        $('#grid_container_latest').fadeOut(50);
        $('#grid_container_market').fadeIn(100);
    });
    $('#filter_news_tab_new').on('click', function(){
        $(this).addClass('active');
        $('#filter_news_tab_market').removeClass('active');
        $('#grid_container_market').fadeOut(50);
        $('#grid_container_latest').fadeIn(100);
    })
    // END N e w s  i n  T a x o n o m y //

    // N e w s  i n  A r c h i v e //
    if( $('#archive-business-section').length ){
        let category;

        const isMobile = window.matchMedia("(max-width: 950px)").matches;

        if (isMobile) {
            // Mobile: leer del <select>
            category = $('#filter_business_mobile').val();
        } else {
            // Desktop: leer del <li class="active">
            const first_category = $('#filter_business_desktop').find('.filter_archive_block.active');
            category = first_category.data('filter');
        }
        loadArchiveNews(category);
    }
     $('.filter_archive_block').on('click', function(){
        $('.filter_archive_block').removeClass('active');
        $(this).addClass('active');
        let category = $(this).data('filter');
        $('#filter_business_mobile').val(category); // sincroniza móvil
        loadArchiveNews( category );
    });

    $('#filter_business_mobile').on('change', function () {
        let category = $(this).val();
        $('.filter_archive_block').removeClass('active');
        $('.filter_archive_block[data-filter="' + category + '"]').addClass('active'); // sincroniza desktop
        loadArchiveNews(category);
    });
    // N e w s  i n  A r c h i v e //
});

function loadHomeNews( page_id, category ){
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'latest_home',
            page_id: page_id,
            categoria: category
        },
        success: function(response) {
            $('#home_latest_news').html(response);
            window.dispatchEvent(new Event('home:section-content-updated'));
        },
        error: function(xhr) {
            console.error('Error al cargar eventos:', xhr);
        }
    });
}

let rafTimeout = null;
function loadArchiveNews( category ){
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'archive_news',
            categoria: category
        },
        success: function(response) {
            $('#business_latest_news').html(response);
            if (rafTimeout) cancelAnimationFrame(rafTimeout);
            rafTimeout = requestAnimationFrame(() => {
                igualarAlturasBusinessNewsYReport();
                igualarAlturasTitulosOnlyNews();
            });
        },
        error: function(xhr) {
            console.error('Error al cargar eventos:', xhr);
        }
    });
}

function igualarAlturasBusinessNewsYReport() {
    if (window.innerWidth <= 950) return;

    const $wrap = $('.archive-news__business-news-reports');
    if (!$wrap.length) return;

    const $news = $wrap.find('.archive-news__business-news');
    const $report = $wrap.find('.archive-news__business-online-report');
    const $imageContainer = $report.find('.image-container');
    const $dataContainer = $report.find('.data-container');

    // Reset
    $news.css('height', 'auto');
    $imageContainer.css('height', 'auto');

    // Medidas
    const heightNews = $news.outerHeight();
    const heightData = $dataContainer.outerHeight();

    // Altura mínima que debe tener toda la card del online report
    const alturaDeseada = heightNews;

    // Calculamos cuánto debería medir la imagen
    const nuevaAlturaImagen = alturaDeseada - heightData;

    if (nuevaAlturaImagen > 0) {
        $imageContainer.css('height', nuevaAlturaImagen + 'px');
    }
}

function igualarAlturasTitulosOnlyNews() {
    if (window.innerWidth <= 950) return;

    const $container = $('.archive-news__business-only-news');
    if (!$container.length) return;

    const $titles = $container.find('.title-container');

    $titles.css('height', 'auto');

    let maxHeight = 0;
    $titles.each(function () {
        const h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
    });

    $titles.height(maxHeight);
}

const featured_id = $('#last_online_report').val();

function igualarAlturasOnlineReports() {
    if (window.innerWidth <= 950) return;
    const clases = ['.data-container', '.title-container'];

    clases.forEach(function(clase) {
        // Reinicia alturas
        $('.news-tax__grid-market-block ' + clase).css('height', 'auto');

        // Agrupar en pares (2 columnas por fila)
        let items = $('.news-tax__grid-market-block');
        for (let i = 0; i < items.length; i += 2) {
            let $rowItems = items.slice(i, i + 2); // grupo de A-B, C-D, etc.
            let maxHeight = 0;

            $rowItems.find(clase).each(function() {
                let altura = $(this).outerHeight();
                if (altura > maxHeight) maxHeight = altura;
            });

            $rowItems.find(clase).height(maxHeight);
        }
    });
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function loadAllNewsByCategory(category, paged = 1, size = 8) {
    loadOnlineReports(category, paged, size);
    loadNewsArchive(category, paged, size);
    window.dispatchEvent(new Event('home:section-content-updated'));
}

function loadOnlineReports(category, paged = 1, size = 8) {
    $.ajax({
        type: 'POST',
        dataType: 'json', // ← porque devuelve { soloNewsView, html }
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'online_reports',
            categoria: category,
            paged: paged,
            size: size,
            featured_id: featured_id
        },
        success: function(response) {
            if (response.soloNewsView) {
                // 🔒 No hay reports: se activa solo la vista "news"
                $('#grid_container_market').hide();
                $('#filter_news_tab_market').hide();
                $('#filter_news_tab_market').removeClass('active');
                $('#filter_news_tab_news').addClass('active');
                $('#grid_container_latest').hide();

                // Si existe la grid de solo noticias
                if ($('#grid_container_only_news').length) {
                    $('#grid_container_only_news').show();
                    loadNewsArchive(category, 1, size, true); // ← forzamos soloNewsView
                } else {
                    // Si no existe esa grid (fallback)
                    loadNewsArchive(category, 1, size, false);
                    $('#grid_container_latest').show();
                }
            } else {
                // ✅ Hay reports: render normal
                $('#grid_container_market').html(response.html).show();
                $('#filter_news_tab_market').show();
                $('#grid_container_latest').show();
                $('#grid_container_only_news').hide();
                $('#filter_news_tab_market').addClass('active');
                $('#filter_news_tab_news').removeClass('active');

                // 🔁 Solo cargar noticias en primera página (evita reset en paginación)
                if (paged === 1) {
                    loadNewsArchive(category, 1, size, false);
                }

                igualarAlturasOnlineReports();
            }
        },
        error: function(xhr) {
            console.error('Error al cargar reports:', xhr);
        }
    });
}

function loadNewsArchive(category, paged = 1, size = 8, soloNewsView = false) {
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'news',
            categoria: category,
            paged: paged,
            size: size,
            soloNewsView: soloNewsView ? 1 : 0
        },
        success: function(response) {
            const container = soloNewsView && $('#grid_container_only_news').length
                ? '#grid_container_only_news'
                : '#grid_container_latest';

            $(container).html(response);
        },
        error: function(xhr) {
            console.error('Error al cargar noticias:', xhr);
        }
    });
}

// ONLINE REPORT paginador
$(document).on('click', '.page-num-report, .btn--next-report, .btn--prev-report', function (e) {
    e.preventDefault();
    const paged = parseInt($(this).data('page'));
    const category = getActiveCategory();
    loadOnlineReports(category, paged, 8); // solo reports
    scrollToGridWrapper();
});

// NEWS paginador
$(document).on('click', '.page-num-news, .btn--next-news, .btn--prev-news', function (e) {
    e.preventDefault();
    const paged = parseInt($(this).data('page'));
    const category = getActiveCategory();
    const soloNewsView = $('#grid_container_only_news').is(':visible');
    loadNewsArchive(category, paged, 8, soloNewsView);
    scrollToGridWrapper();
});

function scrollToGridWrapper() {
    requestAnimationFrame(() => {
        const target = $('#grid_tax_wrapper');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 170
            }, 400);
        }
    });
}

function getActiveCategory() {
    return $('#filter_news_categories_grid_mobile').is(':visible')
        ? $('#filter_news_categories_grid_mobile').val()
        : $('#filter_news_categories_grid_desktop .filter_grid_block.active').data('filter');
}